import './force-sw-reload-modal.scss'

import { Component } from 'vue-property-decorator'
import { BModal } from 'bootstrap-vue'

import { ReactiveVue } from "@skinsoft/reactive-vue"
import { FORCE_UPDATE_SERVICE_WORKER_TOPIC } from '@skinsoft/bus/src/busTopics'

declare const BUILD_ISO_DATE: string
const VERSION: string = '1.1'

@Component({
    template: require('./force-sw-reload-modal.html')
})
export class ForceSwReloadModal extends ReactiveVue {
    private version: string = VERSION
    private buildDate = new Date(BUILD_ISO_DATE)

    public $refs: {
        modal: BModal
    }

    private forceUpdateServiceWorker() {
        this.emitOnBus(FORCE_UPDATE_SERVICE_WORKER_TOPIC)
        this.$refs.modal.hide()
    }

    private update() {
        // @ts-ignore
        location.reload(true)
    }

    public openModal() {
        this.$refs.modal.show()
    }
}